import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
// material
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Radio,
  tableCellClasses,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { styled } from '@mui/material/styles';
// icons
import CloseIcon from '@mui/icons-material/Close';
import { AiFillEdit } from 'react-icons/ai';
// react icons
import { BiShareAlt } from 'react-icons/bi';
import { MdEmail, MdPublishedWithChanges, MdTextsms } from 'react-icons/md';
import { RiWhatsappFill } from 'react-icons/ri';
// table
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { HiOutlineChevronDoubleDown } from 'react-icons/hi';

// components
import LinearProgressValue from '../services/LinearProgressValue';

import Loader from './Loader';
import { CommonApiforJourney } from '../services/RecommendationApi';

import { domainUrl } from '../services/globalApi';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    padding: '6px',
    height: '42.5px',
    fontWeight: 500,
    textTransform: 'uppercase',
    color: '#0d4689'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    padding: '4px 6px',
    height: '42.5px'
  }
}));
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  margin: '0 3px',
  [`&:hover`]: {
    color: theme.palette.primary.main
  }
}));

function RecommendationResult({ addCase, getrecomdationDataList }) {
  // console.log('hihih', addCase, getrecomdationDataList);
  const navigate = useNavigate();
  const [sharePopUp, setSharePopUp] = useState(false);
  const [isActive, setActive] = useState(false);
  const toggleClass = (box) => {
    setActive(box);
  };

  const [openLoader, setOpenLoader] = useState(false);
  const [recommResultStatus, setRecommResultStatus] = useState(true);
  const [recommendationViewState, setRecommendationViewState] = useState([]);
  const [checkedCount, setCheckedCount] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const [errorHandling, setErrorHandling] = useState({ open: false, message: null });
  const { LoginData } = useLoginSelector();

  useEffect(() => {
    recommendationApiFire('recommendationView', null);
  }, []);

  useEffect(() => {
    if (showMore === false) {
      if (
        recommendationViewState !== null &&
        recommendationViewState !== undefined &&
        recommendationViewState.length > 0
      ) {
        recommendationViewState.forEach((item, indexNo) => {
          item.showLimit = true;
          if (indexNo < 2) {
            item.showLimit = true;
          } else {
            item.showLimit = false;
          }
        });

        setRecommendationViewState([...recommendationViewState]);
      }
    }
  }, [showMore]);

  useEffect(() => {
    setOpenLoader(true);
    setRecommendationViewState(getrecomdationDataList);
    setTimeout(() => {
      setOpenLoader(false);
    }, 500);
  }, [getrecomdationDataList]);

  const recommendationApiFire = async (type, condition) => {
    if (LoginData !== null && LoginData !== undefined) {
      const viewRecommendationData = JSON.parse(localStorage.getItem('viewRecommendation'));

      const companyIdObj = {
        companyId: LoginData?.companyId,
        userId: LoginData?.userId
      };
      // let methodName = '';
      // let endapiPath = '';
      const token = LoginData?.jwt;
      // if (type === 'Convert to Lead') {
      //   if (
      //     recommendationViewState !== null &&
      //     recommendationViewState !== undefined &&
      //     recommendationViewState.length > 0
      //   ) {
      //     recommendationViewState.forEach((itemList) => {
      //       if (itemList.is_selected === true) {
      //         companyIdObj.recommendationId = itemList.partner_recommendation_id;
      //         companyIdObj.preferredBankId = itemList.bank_id;
      //         companyIdObj.recommendationResultId = itemList.id;
      //         methodName = 'PUT';
      //         endapiPath = `recommendation/convert`;
      //         recommendationApiFireResponse(
      //           type,
      //           methodName,
      //           endapiPath,
      //           JSON.stringify(companyIdObj),
      //           token,
      //           ''
      //         );
      //       }
      //     });
      //   }
      // }
    }
  };

  const recommendationApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      if (type === 'Convert to Lead') {
        setOpenLoader(false);
        setErrorHandling({ open: true, message: responseData.msg });
        navigate(`/leads`);
      }
    } else if (responseData.status === 'error') {
      setOpenLoader(false);
      setErrorHandling({ open: true, message: responseData.msg });
    }
  };

  return (
    <>
      <Grid container spacing={3} mb={3} alignItems="center">
        <Grid item xs>
          {recommendationViewState !== null &&
          recommendationViewState !== undefined &&
          recommendationViewState.length > 0 ? (
            <Box className="linearProgressBox">
              <Typography
                className=""
                variant="body2"
                sx={{ whiteSpace: 'nowrap', marginRight: '0.75rem', lineHeight: '16px' }}
              >
                Information Completed
              </Typography>
              <LinearProgressValue completedValue={recommendationViewState[0].completion} />
            </Box>
          ) : (
            ''
          )}
        </Grid>

        <Grid item xs="auto">
          <Box textAlign="right">
            {addCase === 'no' ? (
              <Tooltip title="Edit" placement="top" arrow>
                <IconButton
                  className="squareIconButton"
                  onClick={(e) => {
                    let apiCredentials = localStorage.getItem(`apiCredentials`);
                    apiCredentials = JSON.parse(apiCredentials);

                    let viewRecommendation = localStorage.getItem(`viewRecommendation`);
                    viewRecommendation = JSON.parse(viewRecommendation);

                    // console.log('itemObj', apiCredentials, viewRecommendation);

                    const authToken = LoginData?.jwt;
                    const userId = LoginData?.userId;
                    const appToken = CryptoJS.AES.encrypt(
                      viewRecommendation.recommendationId
                        ? String(viewRecommendation.recommendationId)
                        : 'null',
                      'appToken'
                    ).toString();
                    const companyToken = CryptoJS.AES.encrypt(
                      apiCredentials.companyId ? String(apiCredentials.companyId) : 'null',
                      'companyToken'
                    ).toString();
                    const userToken = CryptoJS.AES.encrypt(authToken, 'userToken').toString();
                    const userIdToken = CryptoJS.AES.encrypt(String(userId), 'userId').toString();
                    const loanIdToken = CryptoJS.AES.encrypt(
                      String(apiCredentials?.loanTypeId?.parentLoanId),
                      'loanIdToken'
                    ).toString();
                    const loanTypeIdToken = CryptoJS.AES.encrypt(
                      String(apiCredentials?.loanSubTypeId?.loanId),
                      'loanTypeIdToken'
                    ).toString();

                    window.open(
                      viewRecommendation.recommendationId !== null
                        ? `${domainUrl}recommendation/recommendation-application?u=${encodeURIComponent(
                            userToken
                          )}&c=${encodeURIComponent(companyToken)}&a=${encodeURIComponent(
                            appToken
                          )}&ui=${encodeURIComponent(userIdToken)}&li=${encodeURIComponent(
                            loanIdToken
                          )}&lti=${encodeURIComponent(
                            loanTypeIdToken
                          )}&applicationCreationEntryPlatform=${
                            viewRecommendation?.applicationCreationEntryPlatform
                          }`
                        : `${domainUrl}recommendation/recommendation-configure?u=${encodeURIComponent(
                            userToken
                          )}&c=${encodeURIComponent(companyToken)}&a=${encodeURIComponent(
                            appToken
                          )}&ui=${encodeURIComponent(
                            userIdToken
                          )}&applicationCreationEntryPlatform=${
                            viewRecommendation?.applicationCreationEntryPlatform
                          }`,
                      `_blank`
                    );
                  }}
                >
                  <AiFillEdit size={18} />
                </IconButton>
              </Tooltip>
            ) : (
              ''
            )}
            &nbsp;&nbsp;&nbsp;
            <Tooltip title="Share" placement="top" arrow>
              <IconButton className="squareIconButton" onClick={(e) => setSharePopUp(true)}>
                <BiShareAlt size={18} />
              </IconButton>
            </Tooltip>
            {/* &nbsp;&nbsp;&nbsp;
            <Tooltip title="Convert to Lead" placement="top" arrow>
              <IconButton
                disabled={checkedCount}
                className="squareIconButton"
                onClick={() => {
                  recommendationApiFire('Convert to Lead', null);
                }}
              >
                <MdPublishedWithChanges size={18} />
              </IconButton>
            </Tooltip> */}
          </Box>
          {/* Share popup start */}
          <Dialog open={sharePopUp} onClose={(e) => setSharePopUp(false)} fullWidth>
            <DialogTitle className="popupTitle">
              <Typography variant="h6">Select Sharing Option</Typography>
              <IconButton onClick={(e) => setSharePopUp(false)} size="small">
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent dividers>
              <Box className="displayFlex alignItemCenter justifyContentCenter" mb={2}>
                <Box
                  className={
                    isActive === 'whatsapp' ? 'mailSMSType mr-2 active' : 'mailSMSType mr-2'
                  }
                  onClick={(e) => toggleClass('whatsapp')}
                >
                  <RiWhatsappFill color="#2CB742" size={48} />
                </Box>
                <Box
                  className={isActive === 'email' ? 'mailSMSType mr-2 active' : 'mailSMSType mr-2'}
                  onClick={(e) => toggleClass('email')}
                >
                  <MdEmail color="#0d4689" size={48} />
                </Box>
                <Box
                  className={isActive === 'sms' ? 'mailSMSType mr-2 active' : 'mailSMSType mr-2'}
                  onClick={(e) => toggleClass('sms')}
                >
                  <MdTextsms color="#4fbbc8" size={48} />
                </Box>
              </Box>
              <FormControl required fullWidth className="formGroup">
                <Typography variant="body1" className="formLabel">
                  Email/Mobile
                </Typography>
                <TextField
                  fullWidth
                  inputProps={{ className: 'textInput' }}
                  placeholder="Enter Email/Mobile"
                />
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button onClick={(e) => setSharePopUp(false)} variant="contained" className="mainBtn">
                Send
              </Button>
            </DialogActions>
          </Dialog>
          {/* Share popup end */}
          {/* Convert popup start */}
          <Dialog
            open={errorHandling.open}
            onClose={(e) => setErrorHandling({ open: false, message: null })}
            fullWidth
          >
            <DialogContent dividers>
              <Box className="" py={2}>
                {errorHandling.message}
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(e) => {
                  setErrorHandling({ open: false, message: null });
                }}
                variant="contained"
                className="mainBtn"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          {/* Share popup end */}
        </Grid>
      </Grid>

      {recommendationViewState !== null &&
        recommendationViewState !== undefined &&
        recommendationViewState.length > 0 &&
        recommendationViewState.map((recommendationViewStateItem, indexNo) => (
          <Box className="viewLeadCard noPadding" mb={3}>
            <Box className="bankRecoBox">
              <Box className="displayFlex alignItemCenter" mb={2}>
                <img
                  alt={
                    recommendationViewStateItem.bank_name !== null &&
                    recommendationViewStateItem.bank_name !== undefined &&
                    recommendationViewStateItem.bank_name !== ''
                      ? `${recommendationViewStateItem.bank_name}`
                      : 'Not Available'
                  }
                  className="c-rate-bank-logo"
                  src={recommendationViewStateItem.bank_logo}
                  width="32"
                  height="32"
                />
                <Typography className="ml-2" variant="h6">
                  {recommendationViewStateItem.bank_name !== null &&
                  recommendationViewStateItem.bank_name !== undefined &&
                  recommendationViewStateItem.bank_name !== ''
                    ? `${recommendationViewStateItem.bank_name}`
                    : 'Not Available'}
                </Typography>
              </Box>
              <Typography variant="h2" mb={2}>
                Congratulations !!!
              </Typography>
              <Typography variant="h6" mb={2}>
                Your are eligible to get a loan of
              </Typography>
              <Typography variant="h4" mb={4}>
                {recommendationViewStateItem.loan_amount !== null &&
                recommendationViewStateItem.loan_amount !== undefined &&
                recommendationViewStateItem.loan_amount !== ''
                  ? `INR ${recommendationViewStateItem.loan_amount}`
                  : 'Not Available'}
              </Typography>
              <Box className="viewLeadCard" sx={{ width: '50%' }}>
                <Grid container spacing={2} alignItems="flex-start">
                  <Grid item xs textAlign="center">
                    <Typography variant="body2">INTEREST RATE</Typography>
                    <Typography variant="subtitle2">
                      {recommendationViewStateItem.interest_rate !== null &&
                      recommendationViewStateItem.interest_rate !== undefined &&
                      recommendationViewStateItem.interest_rate !== ''
                        ? `${recommendationViewStateItem.interest_rate} %`
                        : 'Not Available'}
                    </Typography>
                  </Grid>
                  <Grid item xs textAlign="center">
                    <Typography variant="body2">EMI</Typography>
                    <Typography variant="subtitle2">
                      {recommendationViewStateItem.emi !== null &&
                      recommendationViewStateItem.emi !== undefined &&
                      recommendationViewStateItem.emi !== ''
                        ? `Rs ${parseFloat(recommendationViewStateItem.emi).toFixed(2)} Months`
                        : 'Not Available'}{' '}
                    </Typography>
                  </Grid>
                  <Grid item xs textAlign="center">
                    <Typography variant="body2">TENURE</Typography>
                    <Typography variant="subtitle2">
                      {recommendationViewStateItem.tenure !== null &&
                      recommendationViewStateItem.tenure !== undefined &&
                      recommendationViewStateItem.tenure !== ''
                        ? `${recommendationViewStateItem.tenure} Months`
                        : 'Not Available'}
                    </Typography>
                  </Grid>
                  <Grid item xs textAlign="center">
                    <Typography variant="body2">PROCESSING FEES</Typography>
                    <Typography variant="subtitle2">
                      {recommendationViewStateItem.processing_fees !== null &&
                      recommendationViewStateItem.processing_fees !== undefined &&
                      recommendationViewStateItem.processing_fees !== ''
                        ? `${recommendationViewStateItem.processing_fees} + GST`
                        : 'Not Available'}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        ))}

      {recommendationViewState === null ||
      recommendationViewState === undefined ||
      recommendationViewState?.length === 0 ? (
        <Box
          className="viewLeadCard displayFlex alignItemCenter justifyContentCenter"
          sx={{ height: '50vh' }}
        >
          <Typography variant="h5" className="colorBlue">
            No recommendation available for the current input data, please try again later
          </Typography>
        </Box>
      ) : (
        ''
      )}

      <Loader openLoader={openLoader} />
    </>
  );
}
export default RecommendationResult;
